import { render } from "./ToolSelectionPage.vue?vue&type=template&id=453bee21&scoped=true"
import script from "./ToolSelectionPage.vue?vue&type=script&lang=js"
export * from "./ToolSelectionPage.vue?vue&type=script&lang=js"

import "./ToolSelectionPage.vue?vue&type=style&index=0&id=453bee21&lang=css"
import "./ToolSelectionPage.vue?vue&type=style&index=1&id=453bee21&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453bee21"]])

export default __exports__